import svgPaths from "./svg-10hnch8oov";

function Component1032() {
  return (
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 165 49">
      <g id="ê·¸ë£¹ 1032">
        <path d={svgPaths.p93ba400} fill="var(--fill-0, #F6F6F6)" id="í¨ì¤ 1497" />
        <path d={svgPaths.p20d71180} fill="var(--fill-0, #F6F6F6)" id="í¨ì¤ 1498" />
        <path d={svgPaths.p39d3e780} fill="var(--fill-0, #F6F6F6)" id="í¨ì¤ 1499" />
        <path d={svgPaths.p1e0ecf00} fill="var(--fill-0, #F6F6F6)" id="í¨ì¤ 1500" />
        <path d={svgPaths.p3d339f40} fill="var(--fill-0, #F6F6F6)" id="í¨ì¤ 1501" />
        <g id="ê·¸ë£¹ 1026">
          <path d={svgPaths.pdb5e900} fill="var(--fill-0, #04CE7D)" id="í¨ì¤ 1502" />
        </g>
        <g id="ê·¸ë£¹ 1027">
          <g id="ì  55"></g>
          <path d={svgPaths.p1f8a9200} fill="var(--fill-0, #04CE7D)" id="í¨ì¤ 1503" />
        </g>
        <g id="ê·¸ë£¹ 1028">
          <g id="ì  56"></g>
          <path d={svgPaths.p1a5ec00} fill="var(--fill-0, #04CE7D)" id="í¨ì¤ 1504" />
        </g>
        <g id="ê·¸ë£¹ 1029">
          <g id="ì  57"></g>
          <path d={svgPaths.p81a1e80} fill="var(--fill-0, #04CE7D)" id="í¨ì¤ 1505" />
        </g>
        <g id="ê·¸ë£¹ 1030">
          <path d={svgPaths.p208c7600} fill="var(--fill-0, #04CE7D)" id="íì 74" />
        </g>
        <g id="ê·¸ë£¹ 1031">
          <path d={svgPaths.p302663f0} fill="var(--fill-0, #04CE7D)" id="íì 75" />
        </g>
      </g>
    </svg>
  );
}

export default function Component1035() {
  return (
    <div className="relative size-full" data-name="그룹 1035">
      <Component1032 />
    </div>
  );
}